module.exports = __webpack_public_path__ + "0503a1cfcecb7d1395a3b050db4afcef.pdf";